import * as React from 'react';

import { PageTitle } from '../page-title';

import { MenuTopics } from './menu-topics/menu-topics.container';

export class MenuPage extends React.PureComponent {
  public render() {
    return (
      <div className="menu-page">
        <PageTitle text="Menu" />

        <div className="menu-page__content">
          <MenuTopics />
        </div>
      </div>
    );
  }
}
